module.exports = __webpack_public_path__ + "static/media/1@3x.57eba521.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/1@3x.png
// module id = 754
// module chunks = 0